// Import

// Libraries
import styled from 'styled-components';

export const FlexColumnSpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
`;

export const FlexColumnCenterCenter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FlexRowCenterCenter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const GrowSpace = styled.div`
  flex-grow: ${props => props.flexGrow || '1'};
`;
